export default {
  metadata: {
    version: '1.0.0',
    id: 'selector-button-1.0.0',
    name: 'JDSSelectorButton',
    description:
      'A selector button is an interactive control that allows the user to perform a selection action.'
  },
  hierarchy: {
    container: ['left-icon', 'jds-text', 'right-icon']
  },
  base: {
    container: {
      'background-color': '{s_0}',
      'flex-direction': '{s_1}',
      'justify-content': '{s_2}',
      'align-items': '{s_3}',
      'border-radius': '{s_4}',
      'padding-bottom': '{s_5}',
      'padding-top': '{s_6}',
      'padding-left': '{s_7}',
      'padding-right': '{s_8}',
      'border-width': '{s_9}',
      gap: '{s_10}',
      opacity: '{s_11}',
      behavior: {
        hover: {
          'background-color': '{s_12}'
        },
        active: {
          'background-color': '{s_13}'
        },
        focus: {
          'border-width': '{s_14}',
          'border-color': '{s_15}'
        }
      }
    },
    'left-icon': {
      hidden: false,
      size: '{s_16}',
      color: '{s_17}',
      behavior: {
        hover: {
          color: '{s_18}'
        }
      }
    },
    'right-icon': {
      hidden: true,
      size: '{s_19}',
      color: '{s_20}',
      behavior: {
        hover: {
          color: '{s_21}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_137}',
      color: '{text_18}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    }
  },
  variant: {
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{s_22}'
        }
      }
    }
  },
  combination: [
    {
      normal: {
        primary: {
          true: {
            container: {
              'background-color': '{s_23}',
              behavior: {
                hover: {
                  'background-color': '{s_24}'
                },
                active: {
                  'background-color': '{s_25}'
                },
                focus: {
                  'border-color': '{s_26}'
                }
              }
            }
          },
          false: {
            'jds-text': {
              behavior: {
                hover: {
                  color: '{text_12}'
                }
              }
            }
          }
        },
        secondary: {
          false: {
            container: {
              'background-color': '{s_27}',
              'border-width': '{s_28}',
              'border-color': '{s_29}',
              behavior: {
                hover: {
                  'background-color': '{s_30}',
                  'border-color': '{s_31}'
                },
                active: {
                  'background-color': '{s_32}'
                },
                focus: {
                  'border-width': '{s_33}',
                  'border-color': '{s_34}'
                }
              }
            },
            'left-icon': {
              color: '{s_35}'
            },
            'right-icon': {
              color: '{s_36}'
            },
            'jds-text': {
              color: '{text_13}'
            }
          },
          true: {
            container: {
              'background-color': '{s_37}',
              'border-width': '{s_38}',
              'border-color': '{s_39}',
              behavior: {
                hover: {
                  'border-color': '{s_40}'
                },
                active: {
                  'background-color': '{s_41}'
                },
                focus: {
                  'border-width': '{s_42}',
                  'border-color': '{s_43}'
                }
              }
            },
            'left-icon': {
              color: '{s_44}',
              behavior: {
                active: {
                  color: '{s_45}'
                }
              }
            },
            'right-icon': {
              color: '{s_46}',
              behavior: {
                active: {
                  color: '{s_47}'
                }
              }
            },
            'jds-text': {
              color: '{text_13}',
              behavior: {
                active: {
                  color: '{text_12}'
                }
              }
            }
          }
        },
        tertiary: {
          true: {
            container: {
              'background-color': '{s_48}',
              behavior: {
                hover: {
                  'background-color': '{s_49}',
                  'border-color': '{s_50}',
                  'border-width': '{s_51}'
                },
                active: {
                  'background-color': '{s_52}'
                },
                focus: {
                  'border-width': '{s_53}',
                  'border-color': '{s_54}'
                }
              }
            },
            'left-icon': {
              color: '{s_55}',
              behavior: {
                active: {
                  color: '{s_56}'
                },
                hover: {
                  color: '{s_57}'
                }
              }
            },
            'right-icon': {
              color: '{s_58}',
              behavior: {
                active: {
                  color: '{s_59}'
                },
                hover: {
                  color: '{s_60}'
                }
              }
            },
            'jds-text': {
              color: '{text_13}',
              behavior: {
                active: {
                  color: '{text_12}'
                },
                hover: {}
              }
            }
          },
          false: {
            container: {
              'background-color': '{s_61}',
              behavior: {
                hover: {
                  'border-width': '{s_62}',
                  'border-color': '{s_63}',
                  'background-color': '{s_64}'
                },
                active: {
                  'background-color': '{s_65}'
                }
              }
            },
            'left-icon': {
              color: '{s_66}',
              behavior: {
                active: {
                  color: '{s_67}'
                },
                hover: {
                  color: '{s_68}'
                }
              }
            },
            'right-icon': {
              color: '{s_69}',
              behavior: {
                active: {
                  color: '{s_70}'
                },
                hover: {
                  color: '{s_71}'
                }
              }
            },
            'jds-text': {
              color: '{text_13}'
            }
          }
        },
        tertiary_narrow: {
          true: {
            container: {
              'background-color': '{s_72}',
              behavior: {
                focus: {
                  'border-width': '{s_73}',
                  'border-color': '{s_74}'
                },
                hover: {
                  'background-color': '{s_75}'
                },
                active: {
                  'background-color': '{s_76}'
                }
              }
            },
            'left-icon': {
              color: '{s_77}',
              behavior: {
                hover: {
                  color: '{s_78}'
                },
                active: {
                  color: '{s_79}'
                }
              }
            },
            'right-icon': {
              color: '{s_80}',
              behavior: {
                hover: {
                  color: '{s_81}'
                },
                active: {
                  color: '{s_82}'
                }
              }
            },
            'jds-text': {
              color: '{text_12}',
              behavior: {
                hover: {
                  color: '{text_13}'
                },
                active: {
                  color: '{text_11}'
                }
              }
            }
          },
          false: {
            container: {
              'background-color': '{s_83}',
              behavior: {
                hover: {
                  'background-color': '{s_84}'
                },
                active: {
                  'background-color': '{s_85}'
                }
              }
            },
            'left-icon': {
              color: '{s_86}',
              behavior: {
                hover: {
                  color: '{s_87}'
                },
                active: {
                  color: '{s_88}'
                }
              }
            },
            'right-icon': {
              color: '{s_89}',
              behavior: {
                hover: {
                  color: '{s_90}'
                },
                active: {
                  color: '{s_91}'
                }
              }
            },
            'jds-text': {
              color: '{text_13}',
              behavior: {
                hover: {
                  color: '{text_14}'
                },
                active: {
                  color: '{text_12}'
                }
              }
            }
          }
        }
      },
      grey_scale: {
        primary: {
          false: {
            container: {
              'background-color': '{s_92}',
              behavior: {
                hover: {
                  'background-color': '{s_93}'
                },
                active: {
                  'background-color': '{s_94}'
                },
                focus: {
                  'border-width': '{s_95}',
                  'border-color': '{s_96}'
                }
              }
            },
            'left-icon': {
              color: '{s_97}',
              behavior: {
                hover: {
                  color: '{s_98}'
                },
                active: {
                  color: '{s_99}'
                }
              }
            },
            'right-icon': {
              color: '{s_100}',
              behavior: {
                hover: {
                  color: '{s_101}'
                },
                active: {
                  color: '{s_102}'
                }
              }
            },
            'jds-text': {
              color: '{text_19}',
              behavior: {
                hover: {
                  color: '{text_12}'
                },
                active: {
                  color: '{text_18}'
                }
              }
            }
          }
        },
        secondary: {
          false: {
            container: {
              'background-color': '{s_103}',
              'border-width': '{s_104}',
              'border-color': '{s_105}',
              behavior: {
                hover: {
                  'background-color': '{s_106}',
                  'border-color': '{s_107}'
                },
                active: {
                  'background-color': '{s_108}'
                },
                focus: {
                  'border-width': '{s_109}',
                  'border-color': '{s_110}'
                }
              }
            },
            'left-icon': {
              color: '{s_111}',
              behavior: {
                hover: {
                  color: '{s_295}'
                }
              }
            },
            'right-icon': {
              color: '{s_112}',
              behavior: {
                hover: {
                  color: '{s_296}'
                }
              }
            },
            'jds-text': {
              color: '{text_21}',
              behavior: {
                hover: {
                  color: '{text_13}'
                }
              }
            }
          },
          true: {
            container: {
              'background-color': '{s_113}',
              'border-width': 1,
              'border-color': '{s_114}',
              behavior: {
                hover: {
                  'border-color': '{s_115}'
                },
                active: {
                  'background-color': '{s_116}'
                },
                focus: {
                  'border-width': '{s_117}',
                  'border-color': '{s_118}'
                }
              }
            },
            'left-icon': {
              color: '{s_119}',
              behavior: {
                active: {
                  color: '{s_120}'
                }
              }
            },
            'right-icon': {
              color: '{s_121}',
              behavior: {
                active: {
                  color: '{s_122}'
                }
              }
            },
            'jds-text': {
              color: '{text_13}',
              behavior: {
                active: {
                  color: '{text_12}'
                }
              }
            }
          }
        },
        tertiary: {
          true: {
            container: {
              'background-color': '{s_123}',
              behavior: {
                hover: {
                  'border-color': '{s_124}',
                  'border-width': '{s_125}'
                },
                active: {
                  'background-color': '{s_126}'
                },
                focus: {
                  'border-width': '{s_127}',
                  'border-color': '{s_128}'
                }
              }
            },
            'left-icon': {
              color: '{s_129}',
              behavior: {
                active: {
                  color: '{s_130}'
                }
              }
            },
            'right-icon': {
              color: '{s_131}',
              behavior: {
                active: {
                  color: '{s_132}'
                }
              }
            },
            'jds-text': {
              color: '{text_13}',
              behavior: {
                active: {
                  color: '{text_12}'
                }
              }
            }
          },
          false: {
            container: {
              'background-color': '{s_133}',
              behavior: {
                hover: {
                  'border-color': '{s_134}',
                  'border-width': '{s_135}',
                  'background-color': '{s_136}'
                },
                active: {
                  'background-color': '{s_137}'
                },
                focus: {
                  'border-width': '{s_138}',
                  'border-color': '{s_139}'
                }
              }
            },
            'left-icon': {
              color: '{s_140}',
              behavior: {
                hover: {
                  color: '{s_141}'
                },
                active: {
                  color: '{s_142}'
                }
              }
            },
            'right-icon': {
              color: '{s_143}',
              behavior: {
                hover: {
                  color: '{s_144}'
                },
                active: {
                  color: '{s_145}'
                }
              }
            },
            'jds-text': {
              color: '{text_21}',
              behavior: {
                hover: {
                  color: '{text_13}'
                },
                active: {
                  color: '{text_13}'
                }
              }
            }
          }
        },
        tertiary_narrow: {
          true: {
            container: {
              'background-color': '{s_146}',
              behavior: {
                hover: {
                  'background-color': '{s_147}'
                },
                focus: {
                  'border-width': '{s_148}',
                  'border-color': '{s_149}'
                }
              }
            },
            'left-icon': {
              color: '{s_150}',
              behavior: {
                hover: {
                  color: '{s_151}'
                },
                active: {
                  color: '{s_152}'
                }
              }
            },
            'right-icon': {
              color: '{s_153}',
              behavior: {
                hover: {
                  color: '{s_154}'
                },
                active: {
                  color: '{s_155}'
                }
              }
            },
            'jds-text': {
              color: '{text_13}',
              behavior: {
                hover: {
                  color: '{text_14}'
                },
                active: {
                  color: '{text_11}'
                }
              }
            }
          },
          false: {
            container: {
              'background-color': '{s_156}',
              behavior: {
                hover: {
                  'background-color': '{s_157}'
                },
                focus: {
                  'border-width': '{s_158}',
                  'border-color': '{s_159}'
                }
              }
            },
            'left-icon': {
              color: '{s_160}',
              behavior: {
                hover: {
                  color: '{s_161}'
                },
                active: {
                  color: '{s_162}'
                }
              }
            },
            'right-icon': {
              color: '{s_163}',
              behavior: {
                hover: {
                  color: '{s_164}'
                },
                active: {
                  color: '{s_165}'
                }
              }
            },
            'jds-text': {
              color: '{text_21}',
              behavior: {
                hover: {
                  color: '{text_14}'
                },
                active: {
                  color: '{text_13}'
                }
              }
            }
          }
        }
      },
      contrast: {
        primary: {
          false: {
            container: {
              'background-color': '{s_166}',
              behavior: {
                hover: {
                  'background-color': '{s_167}'
                },
                active: {
                  'background-color': '{s_168}'
                },
                focus: {
                  'border-width': '{s_169}',
                  'border-color': '{s_170}'
                }
              }
            },
            'left-icon': {
              color: '{s_171}',
              behavior: {
                hover: {
                  color: '{s_172}'
                },
                focus: {
                  color: '{s_173}'
                },
                active: {
                  color: '{s_174}'
                }
              }
            },
            'right-icon': {
              color: '{s_175}',
              behavior: {
                hover: {
                  color: '{s_176}'
                },
                focus: {
                  color: '{s_177}'
                },
                active: {
                  color: '{s_178}'
                }
              }
            },
            'jds-text': {
              color: '{text_20}',
              behavior: {
                hover: {},
                active: {
                  color: '{text_18}'
                }
              }
            }
          },
          true: {
            container: {
              'background-color': '{s_179}',
              behavior: {
                hover: {
                  'background-color': '{s_180}'
                },
                active: {
                  'background-color': '{s_181}'
                },
                focus: {
                  'background-color': '{s_182}',
                  'border-width': '{s_183}',
                  'border-color': '{s_184}'
                }
              }
            },
            'left-icon': {
              color: '{s_185}',
              behavior: {
                hover: {
                  color: '{s_186}'
                }
              }
            },
            'right-icon': {
              color: '{s_187}',
              behavior: {
                hover: {
                  color: '{s_188}'
                }
              }
            },
            'jds-text': {
              behavior: {
                hover: {
                  color: '{text_20}'
                }
              }
            }
          }
        },
        secondary: {
          false: {
            container: {
              'background-color': '{s_189}',
              'border-width': '{s_190}',
              'border-color': '{s_191}',
              behavior: {
                hover: {
                  'background-color': '{s_192}',
                  'border-color': '{s_193}'
                },
                active: {
                  'background-color': '{s_194}'
                },
                focus: {
                  'border-width': '{s_195}',
                  'border-color': '{s_196}'
                }
              }
            },
            'left-icon': {
              color: '{s_197}',
              behavior: {
                hover: {
                  color: '{s_198}'
                },
                active: {
                  color: '{s_199}'
                }
              }
            },
            'right-icon': {
              color: '{s_200}',
              behavior: {
                hover: {
                  color: '{s_201}'
                },
                active: {
                  color: '{s_202}'
                }
              }
            },
            'jds-text': {
              color: '{text_19}',
              behavior: {
                hover: {
                  color: '{text_20}'
                },
                active: {
                  color: '{text_20}'
                }
              }
            }
          },
          true: {
            container: {
              'background-color': '{s_203}',
              'border-width': 1,
              'border-color': '{s_204}',
              behavior: {
                hover: {
                  'border-color': '{s_205}'
                },
                active: {
                  'background-color': '{s_206}'
                },
                focus: {
                  'border-width': '{s_207}',
                  'border-color': '{s_208}'
                }
              }
            },
            'left-icon': {
              color: '{s_209}',
              behavior: {
                active: {
                  color: '{s_210}'
                }
              }
            },
            'right-icon': {
              color: '{s_211}',
              behavior: {
                active: {
                  color: '{s_212}'
                }
              }
            },
            'jds-text': {
              color: '{text_20}',
              behavior: {
                active: {
                  color: '{text_18}'
                }
              }
            }
          }
        },
        tertiary: {
          false: {
            container: {
              'background-color': '{s_213}',
              behavior: {
                hover: {
                  'background-color': '{s_214}',
                  'border-width': 1,
                  'border-color': '{s_215}'
                },
                active: {
                  'background-color': '{s_216}'
                },
                focus: {
                  'border-width': '{s_217}',
                  'border-color': '{s_218}'
                }
              }
            },
            'left-icon': {
              color: '{s_219}',
              behavior: {
                hover: {
                  color: '{s_220}'
                },
                active: {
                  color: '{s_221}'
                }
              }
            },
            'right-icon': {
              color: '{s_222}',
              behavior: {
                hover: {
                  color: '{s_223}'
                },
                active: {
                  color: '{s_224}'
                }
              }
            },
            'jds-text': {
              color: '{text_19}',
              behavior: {
                hover: {
                  color: '{text_20}'
                },
                active: {
                  color: '{text_20}'
                }
              }
            }
          },
          true: {
            container: {
              'background-color': '{s_225}',
              behavior: {
                hover: {
                  'border-width': 1,
                  'border-color': '{s_226}'
                },
                focus: {
                  'border-width': '{s_227}',
                  'border-color': '{s_228}'
                },
                active: {
                  'background-color': '{s_229}'
                }
              }
            },
            'left-icon': {
              color: '{s_230}',
              behavior: {
                active: {
                  'background-color': '{s_231}'
                }
              }
            },
            'right-icon': {
              color: '{s_232}',
              behavior: {
                active: {
                  'background-color': '{s_233}'
                }
              }
            },
            'jds-text': {
              color: '{text_20}',
              behavior: {
                active: {
                  'background-color': 'primary_inverse'
                }
              }
            }
          }
        },
        tertiary_narrow: {
          false: {
            container: {
              'background-color': '{s_234}',
              behavior: {
                focus: {
                  'border-width': '{s_235}',
                  'border-color': '{s_236}'
                },
                hover: {
                  'background-color': '{s_237}'
                },
                active: {
                  'background-color': '{s_238}'
                }
              }
            },
            'left-icon': {
              color: '{s_239}',
              behavior: {
                hover: {
                  color: '{s_240}'
                },
                active: {
                  color: '{s_241}'
                }
              }
            },
            'right-icon': {
              color: '{s_242}',
              behavior: {
                hover: {
                  color: '{s_243}'
                },
                active: {
                  color: '{s_244}'
                }
              }
            },
            'jds-text': {
              color: '{text_19}',
              behavior: {
                hover: {
                  color: '{text_17}'
                },
                active: {
                  color: '{text_16}'
                }
              }
            }
          },
          true: {
            container: {
              'background-color': '{s_245}',
              behavior: {
                focus: {
                  'border-width': '{s_246}',
                  'border-color': '{s_247}'
                },
                hover: {
                  'background-color': '{s_248}'
                },
                active: {
                  'background-color': '{s_249}'
                }
              }
            },
            'left-icon': {
              color: '{s_250}',
              behavior: {
                hover: {
                  color: '{s_251}'
                },
                active: {
                  color: '{s_252}'
                },
                focus: {
                  color: '{s_253}'
                }
              }
            },
            'right-icon': {
              color: '{s_254}',
              behavior: {
                hover: {
                  color: '{s_255}'
                },
                active: {
                  color: '{s_256}'
                },
                focus: {
                  color: '{s_257}'
                }
              }
            },
            'jds-text': {
              color: '{text_16}',
              behavior: {
                hover: {
                  color: '{text_17}'
                },
                active: {},
                focus: {}
              }
            }
          }
        }
      }
    },
    {
      tertiary_narrow: {
        small: {
          container: {
            'padding-bottom': '{s_258}',
            'padding-top': '{s_259}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        medium: {
          container: {
            'padding-bottom': '{s_260}',
            'padding-top': '{s_261}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        large: {
          container: {
            'padding-bottom': '{s_262}',
            'padding-top': '{s_263}',
            'padding-left': 0,
            'padding-right': 0
          }
        },
        extra_large: {
          container: {
            'padding-bottom': '{s_264}',
            'padding-top': '{s_265}',
            'padding-left': 0,
            'padding-right': 0
          }
        }
      }
    },
    {
      true: {
        small: {
          container: {
            'padding-top': '{s_266}',
            'padding-bottom': '{s_267}'
          },
          'left-icon': {
            size: '{s_268}'
          },
          'right-icon': {
            size: '{s_269}'
          },
          'jds-text': {}
        },
        large: {
          container: {
            'padding-top': '{s_270}',
            'padding-left': '{s_271}',
            'padding-bottom': '{s_272}',
            'padding-right': '{s_273}'
          },
          'left-icon': {
            size: '{s_274}'
          },
          'right-icon': {
            size: '{s_275}'
          },
          'jds-text': {
            'font-family': '{text_122}',
            'font-size': '{text_121}',
            'line-height': '{text_123}',
            'letter-spacing': '{text_124}',
            'font-weight': '{text_125}'
          }
        },
        extra_large: {
          container: {
            'padding-top': '{s_276}',
            'padding-right': '{s_277}',
            'padding-bottom': '{s_278}',
            'padding-left': '{s_279}'
          },
          'left-icon': {
            size: '{s_280}'
          },
          'right-icon': {
            size: '{s_281}'
          },
          'jds-text': {
            'font-family': '{text_107}',
            'font-size': '{text_106}',
            'line-height': '{text_108}',
            'letter-spacing': '{text_109}',
            'font-weight': '{text_110}'
          }
        }
      },
      false: {
        small: {
          container: {
            width: '{s_282}',
            height: '{s_283}',
            'padding-left': 0,
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0
          },
          'left-icon': {
            size: '{s_284}'
          },
          'jds-text': {
            hidden: true
          }
        },
        medium: {
          container: {
            width: '{s_285}',
            height: '{s_286}',
            'padding-left': 0,
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0
          },
          'jds-text': {
            hidden: true
          }
        },
        large: {
          container: {
            width: '{s_287}',
            height: '{s_288}',
            'padding-left': 0,
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0
          },
          'left-icon': {
            size: '{s_289}'
          },
          'jds-text': {
            hidden: true
          }
        },
        extra_large: {
          container: {
            width: '{s_290}',
            height: '{s_291}',
            'padding-left': 0,
            'padding-top': 0,
            'padding-right': 0,
            'padding-bottom': 0
          },
          'left-icon': {
            size: '{s_292}'
          },
          'jds-text': {
            hidden: true
          }
        }
      }
    },
    {
      true: {
        right: {
          'left-icon': {
            hidden: true
          },
          'right-icon': {
            hidden: false
          }
        }
      }
    },
    {
      true: {
        true: {
          container: {
            width: '{s_293}',
            'justify-content': '{s_294}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['appearance', 'kind', 'selected'],
    ['kind', 'size'],
    ['_hasText', 'size'],
    ['_hasText', 'iconPosition'],
    ['_hasText', 'stretch']
  ],
  api: {
    config: {
      kind: {
        values: ['primary', 'secondary', 'tertiary', 'tertiary_narrow']
      },
      iconPosition: {
        values: ['left', 'right']
      },
      appearance: {
        values: ['normal', 'grey_scale', 'contrast']
      },
      size: {
        values: ['medium', 'small', 'large', 'extra_large'],
        doc_description: 'Sizes of the button'
      },
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable SelectorButton.'
      },
      selected: {
        values: [false, true]
      },
      stretch: {
        values: [false, true]
      },
      _hasText: {
        values: [true, false]
      }
    },
    data: {
      container: {
        type: {
          name: 'type',
          type: 'string',
          platform: 'web'
        }
      },
      'left-icon': {
        value: {
          type: 'icon',
          name: 'icon'
        }
      },
      'right-icon': {
        value: {
          type: 'icon',
          name: 'icon'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'text'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick',
        onFocus: {
          name: 'onFocus',
          platform: 'web'
        },
        onBlur: {
          name: 'onBlur',
          platform: 'web'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'text'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-pressed': {
            name: '_ariaPressed',
            prop: 'selected'
          }
        }
      }
    }
  }
};
